import { useEffect, useState } from "react";

export function useContainer(ref) {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    const newContainer = document.createElement("div");
    setContainer(newContainer);

    if (ref) {
      ref.appendChild(newContainer);
    }
  }, [ref]);

  return container;
}
